// This Source Code Form is subject to the terms of the Mozilla Public
// License, v. 2.0. If a copy of the MPL was not distributed with this
// file, You can obtain one at https://mozilla.org/MPL/2.0/.
// Site logo placeholder (Lucide plane) — a designed brand mark replaces
// this component later; swap it here without touching the header.
import React from 'react';
import { Icon } from '../icons/Icon';

export function Logo(): React.ReactElement {
  return <Icon name="plane" size={20} />;
}

export default Logo;
